/******************************************************************************
==============================================================================
BabiGO

NotificationItem

Affiche une notification individuelle.

==============================================================================
*/

import {

    useMemo,

} from "react";

import {

    useNavigate,

} from "react-router-dom";

import {

    FiBell,

    FiTruck,

    FiMap,

    FiCreditCard,

    FiUser,

    FiHeadphones,

    FiTrendingUp,

    FiSettings,

    FiCheckCircle,

} from "react-icons/fi";

import "./notificationItem.css";

export default function NotificationItem({

    notification,

    onClick,

    markAsRead,

    markAsUnread,

    archive,

    deleteNotification

}) {

    const navigate = useNavigate();

    
    /* ======================================================================
       NORMALISATION
    ====================================================================== */

    const notificationType =

        notification.type ||

        notification.category ||

        notification.notificationType ||

        "general";


    const notificationTitle =

        notification.title ||

        notification.name ||

        "Notification";


    const notificationMessage =

        notification.message ||

        notification.body ||

        notification.description ||

        "";


    const notificationRoute =

        notification.route ||

        notification.path ||

        notification.url ||

        null;

    /* ======================================================================
       ACTIONS
    ====================================================================== */

    async function handleOpen() {

        /*
        ---------------------------------------------------------------
        Marquer comme lue
        ---------------------------------------------------------------
        */

        if (!notification.isRead) {

            await markAsRead(

                notification.id

            );

        }

        /*
        ---------------------------------------------------------------
        Navigation
        ---------------------------------------------------------------
        */

        if (notificationRoute) {

            navigate(

                notificationRoute

            );

        }

        /*
        ---------------------------------------------------------------
        Callback parent
        ---------------------------------------------------------------
        */

        if (onClick) {

            onClick();

        }

    }

    async function handleMarkAsUnread(event) {

        event.stopPropagation();

        await markAsUnread(

            notification.id

        );

    }

    async function handleArchive(event) {

        event.stopPropagation();

        await archive(

            notification.id

        );

    }

    async function handleDelete(event) {

        event.stopPropagation();

        await deleteNotification(

            notification.id

        );

    }


    /* ======================================================================
    ICONE
    ====================================================================== */

    const Icon = useMemo(() => {

        switch (notificationType) {

            case "trip":

                return FiMap;


            case "driver":

                return FiTruck;


            case "transaction":

                return FiCreditCard;


            case "support":

                return FiHeadphones;


            case "investor":

                return FiTrendingUp;


            case "settings":

                return FiSettings;


            case "user":

                return FiUser;


            default:

                return FiBell;

        }

    }, [

        notificationType,

    ]);

    /* ======================================================================
       UI
    ====================================================================== */

    return (

        <article

            className={

                notification.isRead

                    ? "notification-item"

                    : "notification-item unread"

            }

            onClick={handleOpen}

            role="button"

            tabIndex={0}

            aria-label={notificationTitle}

            onKeyDown={(event) => {

                if (

                    event.key === "Enter" ||

                    event.key === " "

                ) {

                    event.preventDefault();

                    handleOpen();

                }

            }}

        >

            {/* ==============================================================
                ICÔNE
            ============================================================== */}

            <div className="notification-icon">

                <Icon />

            </div>


            {/* ==============================================================
                CONTENU
            ============================================================== */}

            <div className="notification-content">

                <div className="notification-header">

                    <h4>

                        {notificationTitle}

                    </h4>

                    {

                        !notification.isRead && (

                            <span

                                className="notification-unread-dot"

                                aria-label="Notification non lue"

                            />

                        )

                    }

                </div>


                {/* ==========================================================
                    MESSAGE
                ========================================================== */}

                {

                    notificationMessage && (

                        <div className="notification-message">

                            {notificationMessage}

                        </div>

                    )

                }


                {/* ==========================================================
                    META
                ========================================================== */}

                <div className="notification-meta">

                    {

                        notification.createdAt && (

                            <span

                                className="notification-time"

                                title={

                                    new Date(

                                        notification.createdAt?.toDate

                                            ? notification.createdAt.toDate()

                                            : notification.createdAt

                                    ).toLocaleString(

                                        "fr-FR"

                                    )

                                }

                            >

                                {

                                    new Date(

                                        notification.createdAt?.toDate

                                            ? notification.createdAt.toDate()

                                            : notification.createdAt

                                    ).toLocaleTimeString(

                                        "fr-FR",

                                        {

                                            hour: "2-digit",

                                            minute: "2-digit",

                                        }

                                    )

                                }

                            </span>

                        )

                    }


                    {

                        notification.priority && (

                            <span

                                className={

                                    `notification-priority priority-${

                                        notification.priority

                                    }`

                                }

                            >

                                {

                                    notification.priority === "critical"

                                        ? "Urgent"

                                        : notification.priority === "high"

                                            ? "Important"

                                            : notification.priority === "low"

                                                ? "Faible"

                                                : "Information"

                                }

                            </span>

                        )

                    }

                </div>

            </div>


            {/* ==============================================================
                ACTIONS
            ============================================================== */}

            <div

                className="notification-actions"

                onClick={(event) => {

                    event.stopPropagation();

                }}

            >

                {

                    notification.isRead ? (

                        <button

                            type="button"

                            className="notification-action-button"

                            onClick={

                                handleMarkAsUnread

                            }

                            title="Marquer comme non lue"

                            aria-label="Marquer comme non lue"

                        >

                            <FiCheckCircle />

                        </button>

                    ) : (

                        <button

                            type="button"

                            className="notification-action-button"

                            onClick={

                                async (event) => {

                                    event.stopPropagation();

                                    await markAsRead(

                                        notification.id

                                    );

                                }

                            }

                            title="Marquer comme lue"

                            aria-label="Marquer comme lue"

                        >

                            <FiCheckCircle />

                        </button>

                    )


                }


                <button

                    type="button"

                    className="notification-action-button"

                    onClick={handleArchive}

                    title="Archiver"

                    aria-label="Archiver"

                >

                    📦

                </button>


                <button

                    type="button"

                    className="notification-action-button danger"

                    onClick={handleDelete}

                    title="Supprimer"

                    aria-label="Supprimer"

                >

                    ×

                </button>

            </div>

        </article>

    );

}